module.exports = __webpack_public_path__ + "static/img/jiqi-txt7.33234f1.png";


//////////////////
// WEBPACK FOOTER
// ./src/pages/page-one/img/jiqi-txt7.png
// module id = Fjo5
// module chunks = 0